module.exports = __webpack_public_path__ + "img/Unidad11-5.a8a1dc8c.png";